import { render, staticRenderFns } from "./ActionRevaluarOT.vue?vue&type=template&id=279de279&lang=pug"
import script from "./ActionRevaluarOT.vue?vue&type=script&lang=js"
export * from "./ActionRevaluarOT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports